import type { SailPlotExtensionContext } from "@heiselanalytics/sailplot";

const copy = {
  en: {
    eyebrow: "Licenses & Branding",
    title: "Your plot. Your colors.",
    text: "Give your crew a shared sailing board with your logo, URL, and professional exports.",
    action: "Explore branding",
    compactLead: "Your plot.",
    compactHighlight: "Your colors.",
    compactAction: "Explore branding",
    feedbackEyebrow: "Feedback Friday",
    feedbackTitle: "Updates at the end of every week.",
    feedbackText:
      "Share what would make SailPlot better and see community ideas become visible releases.",
    feedbackAction: "Share feedback",
  },
  de: {
    eyebrow: "Lizenzen & Branding",
    title: "Dein Plot. Deine Farben.",
    text: "Gib deiner Crew ein gemeinsames Segelboard mit deinem Logo, deiner URL und professionellen Exporten.",
    action: "Branding ansehen",
    compactLead: "Dein Plot.",
    compactHighlight: "Deine Farben.",
    compactAction: "Branding ansehen",
    feedbackEyebrow: "Feedback Friday",
    feedbackTitle: "Updates am Ende jeder Woche.",
    feedbackText:
      "Sag uns, was SailPlot besser macht, und erlebe, wie Ideen aus der Community zu sichtbaren Releases werden.",
    feedbackAction: "Feedback teilen",
  },
} as const;

export function EmptySelectionSalesPromotion({
  language,
  navigate,
}: SailPlotExtensionContext) {
  const text = copy[language];

  return (
    <div className="sailplot-sidebar-promotions">
      <aside className="sailplot-sales-promo sailplot-sales-promo--sidebar sailplot-feedback-friday-promo">
        <span>{text.feedbackEyebrow}</span>
        <strong>{text.feedbackTitle}</strong>
        <p>{text.feedbackText}</p>
        <button type="button" onClick={() => navigate("/improvement")}>
          {text.feedbackAction}
          <span aria-hidden="true">→</span>
        </button>
      </aside>

      <aside className="sailplot-sales-promo sailplot-sales-promo--sidebar">
        <span>{text.eyebrow}</span>
        <strong>{text.title}</strong>
        <p>{text.text}</p>
        <button type="button" onClick={() => navigate("/customize")}>
          {text.action}
          <span aria-hidden="true">→</span>
        </button>
      </aside>
    </div>
  );
}

export function CompactSalesPromotion({
  language,
  navigate,
}: SailPlotExtensionContext) {
  const text = copy[language];

  return (
    <button
      type="button"
      className="sailplot-sales-promo sailplot-sales-promo--compact"
      aria-label={text.action}
      onClick={() => navigate("/customize")}
    >
      <strong>
        {text.compactLead}{" "}
        <span className="sailplot-sales-promo__color-line">
          {text.compactHighlight}
        </span>
      </strong>
      <em>
        {text.compactAction}
        <span aria-hidden="true">→</span>
      </em>
    </button>
  );
}
